<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M29.83 6.45c1.064-1.489 3.276-1.489 4.34 0l11.697 16.374L57 13.918c1.88-1.504 4.573.054 4.32 2.35l-.047.29-8 37.334c-.263 1.23-1.35 2.108-2.607 2.108H13.333c-1.257 0-2.344-.878-2.607-2.108l-8-37.333c-.525-2.452 2.315-4.207 4.273-2.641l11.132 8.906zM32 12.587l-11.163 15.63c-.89 1.245-2.642 1.488-3.836.532l-7.497-5.997 5.984 27.915h33.021l5.984-27.915L47 28.749c-1.11.887-2.699.741-3.632-.281l-.204-.251L32 12.587zM32 32c2.946 0 5.333 2.388 5.333 5.333 0 2.946-2.387 5.334-5.333 5.334s-5.333-2.388-5.333-5.334C26.667 34.388 29.054 32 32 32z" transform="translate(-66 -1071) translate(66 1071)"/>
            </g>
        </g>
    </g>
</svg>
